import { useEffect, useState } from 'react';
import { AccessTokenUser, getUserFromAccessToken } from '../common/auth';
import { editUserSpaceRole, revokeSpaceAccess } from '../api/workspace';
import { useMutation } from '@tanstack/react-query';
import { WorkspaceAccessRole } from '../types/WorkspaceAccess';
import { queryClient } from '../queryClient';
import { updateUser } from '../api/user';
import { User } from '../types/User';

export const useGetUserFromAccessTokenOld = (afterUserSet?: (user: AccessTokenUser) => any) => {
  const [user, setUser] = useState<AccessTokenUser>();
  useEffect(() => {
    getUserFromAccessToken()
      .then((user) => {
        if (user) {
          setUser(user);

          if (afterUserSet) afterUserSet(user);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }, []);

  return {
    user,
  };
};

export const useUpdateUserSpaceRoleMutation = (
  spaceId: number
  // userEmail: string,
  // newRole: string
) => {
  return useMutation({
    mutationFn: async ({
      userEmail,
      spaceId,
      newRole,
    }: {
      userEmail: string;
      spaceId: number;
      newRole: WorkspaceAccessRole;
    }) => {
      return await editUserSpaceRole(userEmail, '' + spaceId, newRole);
    },
    onSuccess: () => {
      setTimeout(() => {
        queryClient.invalidateQueries({
          queryKey: ['workspaceAccess', spaceId],
        });
        queryClient.invalidateQueries({
          queryKey: ['organization'],
        });
      }, 300);
    },
  });
};

export const useRevokeSpaceAccessMutation = (spaceId: number) => {
  return useMutation({
    mutationFn: async ({ userEmail, spaceId }: { userEmail: string; spaceId: number }) => {
      return await revokeSpaceAccess(userEmail, '' + spaceId);
    },
    onSuccess: () => {
      setTimeout(() => {
        queryClient.invalidateQueries({
          queryKey: ['workspaceAccess', spaceId],
        });
        queryClient.invalidateQueries({
          queryKey: ['organization'],
        });
      }, 300);
    },
  });
};

// update user mutation
export const useUpdateUserMutation = () => {
  return useMutation({
    mutationFn: async ({ updatedFields }: { updatedFields: Partial<User> }) => {
      return (
        await updateUser({
          ...updatedFields,
        })
      ).data;
    },
    onSuccess: async (data) => {
      setTimeout(() => {
        queryClient.invalidateQueries({
          queryKey: ['userFromAccessToken'],
        });
      }, 200);
    },
  });
};
